<template>
    <div>
        <!--  header-->
        <a-page-header style="width: 105%; margin-left: -20px" title="">
            <template slot="tags">
                <a-breadcrumb>
                    <a-breadcrumb-item href="">
                        <a-icon type="safety-certificate" />
                        <span>{{ $t("message.logData.title1") }}</span>
                    </a-breadcrumb-item>
                    <a-breadcrumb-item href="">
                        <a-icon type="user-add" />
                        <span>{{ $t("message.accountDashboard.title1") }}</span>
                    </a-breadcrumb-item>
                </a-breadcrumb>
            </template>
        </a-page-header>
        <div class="page-title" style="margin-bottom: 20px">{{ $t("message.accountDashboard.title1") }}</div>

        <a-spin :spinning="!$store.state.buttonPermission.length">
            <div class="flex flex-direction-column grid-gap-16">
                <a-card v-if="$store.state.buttonPermission.length">
                    <div slot="title">
                        {{ $store.state.buttonPermission.length ? $store.state.buttonPermission[0].plan_id : '-' }}
                        <span style="color:var(--main-color)">{{ $t("message.accountDashboard.title2") }}</span>
                    </div>
                    <div class="scroll-container">
                        <a-icon v-if="canScrollLeft" type="left" class="scroll-arrow left-arrow"
                            @click="scroll('left')" />
                        <div style="width:40px"></div>
                        <div class="cards-wrapper" ref="scrollWrapper">
                            <div class="cards-content" ref="scrollContent">
                                <div v-for="(item) in $store.state.buttonPermission" :key="item.feature_name"
                                    class="plan-item">
                                    <div class="item-title">{{ item.display_name }}</div>
                                    <div class="item-value" v-if="item.feature_type !== 'boolean'">{{ item.feature_value }}</div>
                                    <div class="item-value" v-else>{{ item.feature_value ? $t('message.commonUsage.enable'):$t('message.commonUsage.disable') }}</div>
                                </div>
                            </div>
                        </div>
                        <div style="width:40px"></div>
                        <a-icon v-if="canScrollRight" type="right" class="scroll-arrow right-arrow"
                            @click="scroll('right')" />
                    </div>
                </a-card>
                <div v-for="item in $store.state.buttonPermission" :key="item.feature_name">
                    <a-card v-if="item.feature_type !== 'boolean'">
                        <div slot="title">
                            {{ item.display_name }}
                            <span style="color:var(--main-color)">{{ $t("message.accountDashboard.title2") }}</span>
                        </div>
                        <div class="usage-content">
                            <div class="usage-item">
                                <div class="usage-title">{{ $t("message.accountDashboard.title3") }}</div>
                                <div class="usage-value">{{ item.feature_usage }}</div>
                            </div>
                            <div class="divider"></div>
                            <div class="usage-item">
                                <div class="usage-title">{{ $t("message.accountDashboard.title4") }}</div>
                                <div class="usage-value overage" v-if="item.feature_overage > 0">
                                    -{{ item.feature_overage }}</div>
                                <div class="usage-value" v-else>
                                    {{ item.feature_available }}</div>
                            </div>
                            <div class="divider"></div>
                            <div class="usage-item">
                                <div class="usage-title">{{$t("message.accountDashboard.title5")}}</div>
                                <div class="usage-value overage" v-if="item.feature_overage > 0">{{ ((item.feature_usage
                                    /
                                    item.feature_value) * 100).toFixed(2) }}%</div>
                                <div class="usage-value" v-else>{{ (100 - item.percentage_available).toFixed(2) }}%
                                </div>
                            </div>
                        </div>
                    </a-card>
                </div>

            </div>
        </a-spin>

    </div>
</template>

<script>
export default {
    name: 'accountDashboard',
    data() {
        return {
            canScrollLeft: false,
            canScrollRight: false,
        }
    },
    mounted() {

        this.$store.dispatch('fetchButtonPermission')

    },
    beforeDestroy() {
        this.$refs.scrollWrapper.removeEventListener('scroll', this.checkScroll);
        window.removeEventListener('resize', this.checkScroll);
    },
    watch: {
        '$store.state.buttonPermission': {
            handler(v) {
                if (v.length) {
                    this.$nextTick(() => {
                        this.init()
                    })
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        init() {
            this.checkScroll();
            this.$refs.scrollWrapper && this.$refs.scrollWrapper.addEventListener('scroll', this.checkScroll);
            window.addEventListener('resize', this.checkScroll);
        },
        scroll(direction) {
            const wrapper = this.$refs.scrollWrapper;
            const scrollAmount = 360; // 每次滚动的距离

            if (direction === 'left') {
                wrapper.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
            } else {
                wrapper.scrollBy({ left: scrollAmount, behavior: 'smooth' });
            }
        },
        checkScroll() {
            const wrapper = this.$refs.scrollWrapper;
            if (!wrapper) return
            this.canScrollLeft = wrapper.scrollLeft > 0;
            this.canScrollRight = wrapper.scrollLeft < (wrapper.scrollWidth - wrapper.clientWidth);
        }
    }
}
</script>
<style scoped>
::v-deep .ant-card-head {
    border-bottom: 1px solid #ccc
}

::v-deep .ant-card-body {
    padding-left: 0;
}

.scroll-container {
    display: flex;
    align-items: center;
    position: relative;
}

.cards-wrapper {
    overflow-x: auto;
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;
    /* IE and Edge */
    white-space: nowrap;
    flex: 1;
    padding: 10px 0;
}

.cards-wrapper::-webkit-scrollbar {
    display: none;
    /* Chrome, Safari, Opera */
}

.cards-content {
    display: inline-flex;
}

.plan-item {
    display: inline-block;
    min-width: 180px;
    padding: 0 15px;
    text-align: center;
    border-right: 1px solid #f0f0f0;
}

.plan-item:last-child {
    border-right: none;
}

.item-title {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.45);
    margin-bottom: 8px;
}

.item-value {
    font-size: 20px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
}

.scroll-arrow {
    position: absolute;
    font-size: 18px;
    cursor: pointer;
    padding: 0 10px;
    z-index: 1;
    background: transparent;
    height: 40px;
    line-height: 40px;
    border-radius: 4px;
}


.left-arrow {
    left: 0
}

.right-arrow {
    right: 0
}


.usage-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 0 16px 16px;
}

.usage-item {
    flex: 1;
    text-align: left;
    padding: 0 12px;
}

.usage-title {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.45);
    margin-bottom: 8px;
    line-height: 1.5;
}

.usage-value {
    font-size: 42px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    line-height: 1.5;
}

.divider {
    width: 1px;
    height: 40px;
    background-color: #f0f0f0;
    margin: 0 8px;
}

/* 响应式设计 - 在小屏幕上堆叠显示 */
@media (max-width: 768px) {
    .usage-content {
        flex-direction: column;
    }

    .usage-item {
        width: 100%;
        margin-bottom: 16px;
        padding: 0;
    }

    .divider {
        width: 100%;
        height: 1px;
        margin: 8px 0;
    }
}

.overage {
    color: var(--main-color);
}
</style>